import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url: '/Agency/get_orders_list',
    method: 'get',
    params: params
  })
}

export function get_customer_orders_list(params) {
  return request({
    url: '/Agency/get_customer_orders_list',
    method: 'get',
    params: params
  })
}

// 物流轨迹查询 {num:物流单号, com:快递公司编码, phone:收件人手机号}
export function queryLogistics(params) {
  return request({
    url: '/Logistics/query',
    method: 'get',
    params: params
  })
}

export function order_replenish(params) {
  return request({
    url: '/Agency/order_replenish',
    method: 'post',
    params: params
  })
}

export function order_rebut(params) {
  return request({
    url: '/Agency/order_rebut',
    method: 'post',
    params: params
  })
}

export function get_wx_orders_list(params) {
  return request({
    url: '/Agency/get_wx_orders_list',
    method: 'get',
    params: params
  })
}

export function export_orders_data(params) {
  return request({
    url: '/Agency/export_orders_data',
    method: 'post',
    params: params
  })
}

// 获取订单列表、运费充值、钱包充值、补货订单、退货申请处理的待处理徽标数
export function get_pending_total() {
  return request({
    url: '/Agency/get_pending_total',
    method: 'get'
  })
}

export function get_audit_freight_list(params) {
  return request({
    url: '/Agency/get_audit_freight_list',
    method: 'get',
    params: params
  })
}

export function audit_freight(params) {
  return request({
    url: '/Agency/audit_freight',
    method: 'post',
    params: params
  })
}

export function reject_freight(params) {
  return request({
    url: '/Agency/reject_freight',
    method: 'post',
    params: params
  })
}

export function export_audit_freight_list(params) {
  return request({
    url: '/Agency/export_audit_freight_list',
    method: 'post',
    params: params
  })
}


export function closeOrder(params) {
  return request({
    url: '/order/update/close',
    method: 'post',
    params: params
  })
}

export function deleteOrder(params) {
  return request({
    url: '/order/delete',
    method: 'post',
    params: params
  })
}

export function deliveryOrder(data) {
  return request({
    url: '/Agency/order_confirm',
    method: 'post',
    data: data
  });
}

export function getOrderDetail(params) {
  return request({
    url: '/Agency/get_orders_details',
    method: 'get',
    params: params
  });
}

export function order_upd_remark(data) {
  return request({
    url: '/Agency/order_upd_remark',
    method: 'post',
    data: data
  });
}

export function save_users_addr(data) {
  return request({
    url: '/Agency/save_users_addr',
    method: 'post',
    data: data
  });
}

export function orders_upload(data) {
  return request({
    url: '/JuShuiTan/orders_upload',
    method: 'post',
    data: data
  });
}

export function GetRechargeApplyList(data) {
  return request({
    url: '/UserWallet/GetRechargeApplyList',
    method: 'post',
    data: data
  });
}

export function ExportRechargeApplyList(data) {
  return request({
    url: '/UserWallet/ExportRechargeApplyList',
    method: 'post',
    data: data
  });
}

export function AuditRechargeApply(data) {
  return request({
    url: '/UserWallet/AuditRechargeApply',
    method: 'post',
    data: data
  });
}
 


export function GetConferenceRecordPage(data) {
  return request({
    url: '/Conference/GetConferenceRecordPage',
    method: 'post',
    data: data
  });
}

export function Audit(data) {
  return request({
    url: '/Conference/Audit',
    method: 'get',
    params: data
  });
}



//{pageindex :1, pagesize  :2,keywords:"",suppilerid:0 //0为全部，其他为供货人2id，starttime:null,endtime:null}
export function GetDsOrders(data) {
  return request({
    url: '/User/GetDsOrders',
    method: 'post',
    data: data
  });
}

//{pageindex :1, pagesize  :2,keywords:"",suppilerid:0 //0为全部，其他为供货人2id，starttime:null,endtime:null}
export function ExportDsOrders(data) {
  return request({
    url: '/User/ExportDsOrders',
    method: 'post',
    data: data
  });
}






export function updateReceiverInfo(data) {
  return request({
    url: '/order/update/receiverInfo',
    method: 'post',
    data: data
  });
}

export function updateMoneyInfo(data) {
  return request({
    url: '/order/update/moneyInfo',
    method: 'post',
    data: data
  });
}

export function updateOrderNote(params) {
  return request({
    url: '/order/update/note',
    method: 'post',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js